export const StaffStatuses = [
  {
    value: true,
    text: 'Активна',
  },
  {
    value: false,
    text: 'Неактивна',
  },
];
